import { createReducer } from '../utils/createReducer';
import { setError, setLoading } from '../utils/helpers';
import {
  REQUEST_HERO_BANNER,
  REQUEST_HERO_BANNER_FAIL,
  REQUEST_HERO_BANNER_SUCCESS,
  UPDATE_HERO_BANNER,
  UPDATE_HERO_BANNER_FAIL,
  UPDATE_HERO_BANNER_SUCCESS,
  CREATE_HERO_BANNER,
  CREATE_HERO_BANNER_SUCCESS,
  CREATE_HERO_BANNER_FAIL,
} from '../actionTypes';

const initialState = {
  loading: false,
  error: null,
  ids: [],
  data: {},
};

export const reducer = createReducer(initialState, {
  [REQUEST_HERO_BANNER]: setLoading,
  [REQUEST_HERO_BANNER_FAIL]: setError,
  [REQUEST_HERO_BANNER_SUCCESS]: (state, action) => ({
    ...state, loading: false, errors: null, data: action.payload.data,
  }),

  [UPDATE_HERO_BANNER]: setLoading,
  [UPDATE_HERO_BANNER_FAIL]: setError,
  [UPDATE_HERO_BANNER_SUCCESS]: (state, action) => ({
    ...state, loading: false, errors: null, data: action.payload.data,
  }),

  [CREATE_HERO_BANNER]: setLoading,
  [CREATE_HERO_BANNER_FAIL]: setError,
  [CREATE_HERO_BANNER_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    data: { ...state.data, [action.payload.id]: action.payload },
    ids: state.ids.concat(action.payload.id),
  }),
});
